<template>
    <b-modal
        v-model="show"
        centered
        :title="`Delete field ${field.label}`"
        lazy
    >
        <div class="alert alert-danger">
            Are you sure you want to delete this field?
        </div>

        <div slot="modal-footer">
            <b-btn
                variant="default"
                class="mr-2"
                @click="reset"
            >
                Close
            </b-btn>
            <Button
                variant="danger"
                @click="submit"
            >
                Delete field
            </Button>
        </div>
    </b-modal>
</template>

<script>
import { dispatch, get, sync } from 'vuex-pathify';

export default {
    props: {
        modalTitle: {
            type: String,
            default: 'Add field',
        },
    },
    computed: {
        ...get('document', [
            'field',
        ]),
        show: sync('document/showDeleteFieldModal'),
    },
    methods: {
        reset() {
            dispatch('document/setField', {});
            dispatch('document/setShowDeleteFieldModal', false);
        },
        async submit() {
            await dispatch('document/deleteField', this.field);
            
            this.reset();
        },
    },
};
</script>

<style scoped>

</style>
